<template>
    <div class="container d-flex secondary" v-if="searching">
        <h5 class="mr-2 text-secondary">Fetching...</h5><b-spinner class="text-secondary" />
    </div>
    <div v-else>
        <h5 v-if="history.length === 0" class="text-secondary">No history found.</h5>
        
        <div v-for="(item, index) in history" :key="index">
            <!-- {{ item }} -->
            <b-table-lite v-if="!item.orderId" striped hover small fixed caption-top :fields="fields" :items="item.diffs">
                  <template #table-caption>
                      <span v-if="!item.orderId">{{ item.username }} - {{ moment(item.date).format('M/D/YYYY h:mma') }}</span>
                    </template>

                   <template #cell(field)="data">
                        {{ parseField(data.item.field, data.item) }}
                        <b-badge pill v-if="parseIndex(data.item)">{{ parseIndex(data.item) }}</b-badge>
                    </template>

                    <template #cell(newValue)="data">
                        <span class="no-value" v-if="parseNewValue(data.item) === '(none)'">{{ parseNewValue(data.item) }}</span>
                        <span v-else>{{ parseNewValue(data.item) }}</span>
                    </template>

                    <template #cell(oldValue)="data">
                        <span class="no-value" v-if="parseOldValue(data.item) === '(none)'">{{ parseOldValue(data.item) }}</span>
                        <span v-else>{{ parseOldValue(data.item) }}</span>
                    </template>
            </b-table-lite>

            <b-list-group-item v-else class="mb-3 mt-3">
                <span class="text-success">{{ item.customer }} - {{ moment(item.date).format('M/D/YYYY h:mma') }}</span>
            </b-list-group-item>
        </div>

        <div v-for="(item, index) in archive" :key="'archive' + index">
            <b-table-lite striped hover small fixed caption-top :fields="archiveFields" :items="item.entries">
                <template #table-caption>
                    <span>{{ item.username }} - {{ moment(item.date).format('M/D/YYYY') }}</span>
                </template>

                <template #cell(oldValue)="data">
                        {{ parseArchiveValue(data.item.oldValue, data.item.field) }}              
                </template>

                <template #cell(newValue)="data">
                        {{ parseArchiveValue(data.item.newValue, data.item.field) }}              
                </template>

                <template #cell(field)="data">
                        {{ parseArchiveField(data.item.field, data.item) }}              
                        <small class="text-secondary">{{ moment(data.item.date).format('h:mma')}}</small>
                </template>
            </b-table-lite>
        </div>
    </div>
</template>

<script>
    import inventoryApi from "@/api/inventory";
    import ordersApi from "@/api/orders";
    import moment from "moment";

    export default {
        name: "ItemHistory",
        props: [ "item" ],
        mixins: [ inventoryApi, ordersApi ],
        data() {
            return {
                searching: false,
                history: [],
                archive: [],
                fields: [
                    { key: 'field', label: 'Field' },
                    { key: 'oldValue', label: 'Old' },
                    { key: 'newValue', label: 'New' },
                ],
                archiveFields: [
                    { key: 'field', label: 'Field' },
                    { key: 'oldValue', label: 'Old' },
                    { key: 'newValue', label: 'New' },
                ],
            }
        },
        async created() {
            this.searching = true;
            await this.fetchHistory(this.item._id);
            this.searching = false;
        },
        methods: {
            proper(word) {
                return word.charAt(0).toUpperCase() + word.slice(1);
            },
            parseNewValue(val) {
                if (Array.isArray(val.newValue)) {
                    if (val.added && val.added.length > 0) {
                        return val.added.join(', ');
                    }
                    return val.newValue.join(', ');
                } else if(typeof val.newValue === 'object') {
                    let vals = [];
                    for (let key in val.newValue) {
                        if (key !== '_id') {
                            let value = val.newValue[key];
                            if (!value || value.length === 0) value = '(none)';

                            vals.push(`${this.proper(key)}: ${value}`);
                        }
                    }
                    
                    if (vals.length === 0) {
                        return '(none)';
                    }

                    return vals.join(', ');
                }

                return val.newValue || '(none)';
            },
            parseOldValue(val) {
                if (Array.isArray(val.oldValue)) {
                    if (val.oldValue.length === 0) {
                        return '(none)';
                    }

                    return val.oldValue.join(', ');
                } else if (typeof val.oldValue === 'object') {
                    let vals = [];
                    for (let key in val.oldValue) {
                        if (key !== '_id') {
                            let value = val.oldValue[key];
                            if (!value || value.length === 0) value = '(none)';

                            vals.push(`${this.proper(key)}: ${value}`);
                        }
                    }
                    
                    if (vals.length === 0) {
                        return '(none)';
                    }
                    
                    return vals.join(', ');
                }


                return val.oldValue || '(none)';
            },
            parseIndex(item) {
                let index = !isNaN(item.index) ? `${item.index + 1}` : null;
                return index;
            },
            parseField(field) {
                let keys = field.split('.');
                
                if (keys[1]) {
                    return `${this.proper(keys[0])} ${this.proper(keys[1])}`;
                }

                return `${this.proper(field)}`;
            },
            parseArchiveValue(value, field) {
                if (field === 'Photos') {
                    let photos = value.split(',');
                    return photos.map(photo => {
                        return photo.split('\\').pop().split('/').pop();
                    }).join(', ');
                }

                return value;
            },
            parseArchiveField(field) {
                const fieldMap = {
                    'PressingNotes': 'Notes',
                    'CatCode': 'Location',
                    'BackupQuantity': 'Inactive',
                    'Price': 'Price',
                    'price': 'Price',
                    'modified': 'Modified',
                    'LastModified': 'Modified',
                    'Quantity': 'Active',
                    'CoverParts': 'Cover Parts',
                    'DiscParts': 'Disc Parts',
                    'internalNotes': 'Internal Notes',
                    'ebaySuppress': 'eBay',
                    'source': 'Source',
                    'discogsNo': 'Discogs ID',
                    'LabelNo': 'Catalog Number',
                    'artistLast': 'Artist Last',
                    'artistFirst': 'Artist First',
                    'PotentialQuantity': 'Offline',
                    'offsite': 'offsite',
                };

                if (fieldMap[field]) {
                    return fieldMap[field];
                }

                return field;
            },
            async fetchHistory(id) {
                const history = await this.getItemHistory(id);
                const sales = await this.getItemOrders(this.item.itemId);

                sales.forEach(sale => {
                    history.push({
                        date: sale.createdAt,
                        customer: sale.customer.fullName,
                        platform: sale.platform.site,
                        orderId: sale.orderId,
                    });
                });
                this.history = this.sortHistory(history);
                this.archive = await this.getItemArchive(this.item.itemId);
            },
            sortHistory(history) {
                return history.sort((a, b) => {
                        return moment(b.date) - moment(a.date);
                });
            }
        }
    }
</script>

<style scoped>
    .no-value {
        color: #aaa;
    }
</style>